import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { EmotionProvider as EmotionThemeProvider } from '@tanium/react-emotion';
import { ThemeProvider as TaniumThemeProvider } from '@tanium/react-theme-context';
import { bluestar } from '@tanium/theme-data';
import { WorkspaceSelection } from '../../pages/Login/WorkspaceSelection';
import { WorkspaceHelpPage } from '../../pages/Login/WorkspaceHelpPage';
import { LoginPage } from '../../pages/Login/LoginPage';
import { AuthCallbacks } from '../../auth/Auth';
import { UnauthenticatedRoutes } from './UnauthenticatedRoutes';

interface Props {
  auth: AuthCallbacks;
}

export const UnauthenticatedArea: React.VFC<Props> = ({ auth }) => {
  return (
    <EmotionThemeProvider theme={bluestar}>
      <TaniumThemeProvider theme={bluestar}>
        <Switch>
          <Route path={UnauthenticatedRoutes.WORKSPACE_SELECTION_ROUTE} exact>
            <WorkspaceSelection auth={auth} />
          </Route>
          <Route path={UnauthenticatedRoutes.WORKSPACE_HELP_ROUTE} exact>
            <WorkspaceHelpPage auth={auth} />
          </Route>
          <Route path="/">
            <LoginPage auth={auth} />
          </Route>
        </Switch>
      </TaniumThemeProvider>
    </EmotionThemeProvider>
  );
};
